import { load } from "@cashfreepayments/cashfree-js";
import { api } from "@/lib/api";

function loadRazorpayScript() {
  if (window.Razorpay) return Promise.resolve(true);
  return new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

// Resolves with the verified status for Razorpay; Cashfree redirects away and is verified on return.
export async function startOnlinePayment({ invoice, amount, provider }) {
  const { data } = await api.post("/payments/orders", { invoice_id: invoice.id, amount: Number(amount), provider });
  if (data.provider === "cashfree") {
    const cashfree = await load({ mode: data.mode === "production" ? "production" : "sandbox" });
    await cashfree.checkout({ paymentSessionId: data.payment_session_id, redirectTarget: "_self" });
    return { status: "redirecting" };
  }
  if (!(await loadRazorpayScript())) throw new Error("Could not load Razorpay checkout");
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: data.key_id,
      amount: data.amount,
      currency: "INR",
      order_id: data.order_id,
      name: "SPARKORA EDU",
      description: `Fees ${invoice.period} • ${invoice.receipt_no}`,
      prefill: { name: data.name, email: data.email },
      theme: { color: "#6d28d9" },
      handler: async (res) => {
        try {
          const v = await api.post("/payments/razorpay/verify", { payment_id: data.payment_id, ...res });
          resolve(v.data);
        } catch (e) { reject(e); }
      },
      modal: { ondismiss: () => resolve({ status: "cancelled" }) },
    });
    rzp.on("payment.failed", () => resolve({ status: "failed" }));
    rzp.open();
  });
}

export async function verifyCashfreeReturn(paymentId) {
  const { data } = await api.post(`/payments/cashfree/verify/${paymentId}`);
  return data;
}
